import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import PrepaidPanel from "../../dumb-components/subscriptions/prepaid-panel/prepaid-panel";

const PrepaidContainer = ({ companyDueForCancellation }) => {
  if (companyDueForCancellation) {
    return null;
  }

  return <PrepaidPanel />;
};

const mapStoreToProps = (store) => {
  return {
    companyDueForCancellation: store.company.company?.toBeCanceled,
  };
};

export default injectIntl(connect(mapStoreToProps)(PrepaidContainer));
